export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const SET_START_LOADING_MAIN_SCREEN = 'SET_START_LOADING_MAIN_SCREEN';
export const SET_STOP_LOADING_MAIN_SCREEN = 'SET_STOP_LOADING_MAIN_SCREEN';
export const SET_START_LOADING_ALL_SCREEN = 'SET_START_LOADING_ALL_SCREEN';
export const SET_STOP_LOADING_ALL_SCREEN = 'SET_STOP_LOADING_ALL_SCREEN';

export const ADD_INFO_USER = 'ADD_INFO_USER';
export const REMOVE_INFO_USER = 'REMOVE_INFO_USER';
export const REMOVE_ALL_LIST_DATA = 'REMOVE_ALL_LIST_DATA';
export const REMOVE_ALL_STATE = 'REMOVE_ALL_STATE';

export const LOAD_ALL_DEVICE = 'LOAD_ALL_DEVICE';
export const SET_INFO_AN_USER = 'SET_INFO_AN_USER';
export const ADD_DEVICE = 'ADD_DEVICE';
export const REMOVE_DEVICE = 'REMOVE_DEVICE';
export const LOAD_DETAIL_DEVICE = 'LOAD_DETAIL_DEVICE';

export const SET_LIST_DEVICE_TO_USER = 'SET_LIST_DEVICE_TO_USER';

export const LOAD_LIST_ALL_USER = 'LOAD_LIST_ALL_USER';
export const ADD_USER = 'ADD_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_LIST_ALL_USER = 'SET_LIST_ALL_USER';
export const CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER';
export const HIDE_MENU = 'HIDE_MENU';

// My Code

export const TRIGGER_ADD_LIGHT = 'TRIGGER_ADD_LIGHT';
export const OFF_FORM_ADD_LIGHT = 'OFF_FORM_ADD_LIGHT';
export const DETERMIN_POIN_MAP = 'DETERMIN_POIN_MAP';
export const ADD_NEW_LIGHT = 'ADD_NEW_LIGHT';
export const UPDATE_LIGHT = 'UPDATE_LIGHT';
export const UPDATE_LIGHT_VALUE = 'UPDATE_LIGHT_VALUE';
export const DELETE_LIGHT = 'DELETE_LIGHT';
export const DELETE_ALL_LIGHT = 'DELETE_ALL_LIGHT';
export const LOAD_LIST_LIGHT = 'LOAD_LIST_LIGHT';
export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SHOW_MENU = 'SHOW_MENU';
export const SET_USER_PROFILE = 'SET_USER_PROFILE'

// Dao code
// export const ADD_NEW_STRATEGY = 'ADD_NEW_STRATEGY';
// export const REMOVE_STRATEGY = 'REMOVE_STRATEGY';
// export const CHANGE_TIME_START = 'CHANGE_TIME_START';
// export const CHANGE_TIME_END = 'CHANGE_TIME_END';
// export const CHANGE_DIRECT_START = 'CHANGE_DIRECT_START';
// export const CHANGE_DIRECT_COUNT = 'CHANGE_DIRECT_COUNT';
// export const CHANGE_WALK_START = 'CHANGE_WALK_START';
// export const CHANGE_WALK_COUNT = 'CHANGE_WALK_COUNT';
// export const CHANGE_NUM_PHASE = 'CHANGE_NUM_PHASE';
// export const CLEAR_STRATEGY = 'CLEAR_STRATEGY';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js